// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Link } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconLink(props: any) {
    return <IconBase icon={Link} {...props} />
  }

  export default IconLink
  